import { pdfjs } from "react-pdf";
import { NODE_ENV } from "./config";
import renderApp from "./ui";

// Warning: it's necessary to work with all the browsers
if (NODE_ENV !== "development") {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
}

renderApp();
